module.exports = __webpack_public_path__ + "static/img/5areaB_11.4e93809.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/5areaB_11.png
// module id = 1201
// module chunks = 1